import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { CollectionManager } from '../collection';
import { createEvents, InternalEvent, StorageEvents } from '../event';
import { createStorageAspects, PluginManager } from '../plugin';
import { ModelManager } from '../model';
import { DatabaseManager } from '../database';
import nextTick from '../utils/next-tick';
import { TransactionManager } from '../transaction';
/**
 * A Storage supports complex queries & multi-table transaction
 */
var StructuredStorage = /** @class */ (function () {
    function StructuredStorage(_a) {
        var _b;
        var _this = this;
        var name = _a.name, engine = _a.engine, _c = _a.version, version = _c === void 0 ? 1 : _c, _d = _a.plugins, plugins = _d === void 0 ? [] : _d, _e = _a.disableAutoOpen, disableAutoOpen = _e === void 0 ? false : _e, databaseSchema = _a.databaseSchema, _f = _a.supportCompatibleOpen, supportCompatibleOpen = _f === void 0 ? false : _f;
        this.aspects = createStorageAspects();
        this.eventBus = createEvents();
        this.open = function () {
            _this.transactionManager.openChannels();
            return _this.databaseManager.openDatabase();
        };
        this.close = function () {
            return _this.databaseManager.closeDatabase();
        };
        this.destroy = function () {
            return _this.databaseManager.destroyDatabase();
        };
        this.register = function (modelClass) {
            _this.modelManager.register(modelClass);
        };
        this.collection = function (modelClass) {
            var schema = _this.modelManager.getSchemaAndRegisterModelIfNeed(modelClass);
            return _this.collectionManager.getCollection(schema.name, {
                spawnContext: function () { return _this.transactionManager.spawnAutoCommitContext(); },
            });
        };
        this.transaction = function (models, mode, handleTransaction) { return __awaiter(_this, void 0, void 0, function () {
            var transactionManager, collectionNames, context;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transactionManager = this.transactionManager;
                        collectionNames = models.map(function (model) { return _this.modelManager.getSchemaAndRegisterModelIfNeed(model).name; });
                        context = transactionManager.spawnKeepAliveContext();
                        this.eventBus.emit(InternalEvent.StartTransaction, { collectionNames: collectionNames, context: context });
                        return [4 /*yield*/, context.openTransaction(collectionNames, mode)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, context.autoCommitOrRollback(function () { return handleTransaction(_this.createStorageTransaction(context)); })];
                }
            });
        }); };
        this.name = name;
        this.version = version;
        this.events = new StorageEvents(this.eventBus);
        this.modelManager = new ModelManager(this.eventBus);
        this.databaseManager = new DatabaseManager(this, {
            engine: engine,
            eventBus: this.eventBus,
            databaseSchema: databaseSchema,
            supportCompatibleOpen: supportCompatibleOpen,
        });
        this.pluginManager = new PluginManager(this, this.eventBus);
        this.collectionManager = new CollectionManager(this, this.eventBus);
        this.transactionManager = new TransactionManager(this.eventBus, {
            cmp: this.databaseManager.getDatabaseEngine().cmp,
        });
        (_b = this.pluginManager).add.apply(_b, __spreadArray([], __read(plugins)));
        if (!disableAutoOpen) {
            nextTick(function () {
                return _this.open().catch(function (err) {
                    throw err;
                    // It's safe to ignore the err because it
                    // already emitted a fetal event
                });
            });
        }
    }
    StructuredStorage.prototype.createStorageTransaction = function (context) {
        var modelManager = this.modelManager;
        var collectionManager = new CollectionManager(this, this.eventBus);
        return {
            collection: function (modelClass) {
                var schema = modelManager.getSchemaAndRegisterModelIfNeed(modelClass);
                return collectionManager.getCollection(schema.name, {
                    spawnContext: function () { return context; },
                });
            },
        };
    };
    return StructuredStorage;
}());
export default StructuredStorage;
//# sourceMappingURL=structured-storage.js.map